import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    card: {
      width: '100%',
      height: 100,
      marginLeft: 1,
      marginBottom: 10,
      marginTop: 1,
      marginRight: 1,
      borderRadius: 15,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      border: '0.5px solid #5f5f5f42',
    },
    girdTitle: {
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
      width: '100%',
      marginBottom: '5px',
      padding: '2px 5px',
      background: '#FCD3D3',
      borderRadius: '5px!important',
    },
    textTitle: {
      fontSize: 14,
      color: '#8c4b3e',
      margin: '0px 0px 0px 5px!important',
    },
    textTitleItem: {
      fontSize: 13,
      color: '#444',
      overflow: 'hidden',
      margin: '2px 5px!important',
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'start',
      textAlign: 'left',
      wordWrap: 'break-word',
    },
    titlePromotion: {
      margin: '0px 10px 0px 5px!important',
      color: '#33373c',
      textAlign: 'left',
      fontSize: '13px',
      wordWrap: 'break-word',
      display: '-webkit-box',
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    gridValue: {
      borderRadius: 5,
      margin: '0px 3px',
      padding: '0px',
      display: 'flex',
    },
    textValeu: {
      fontSize: 13,
      color: '#444',
      overflow: 'hidden',
      margin: '0px 2px!important',
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'start',
    },
    textBold: {
      fontWeight: 'bolder',
    },
    iconPlusValue: {
      marginRight: 5,
    },
    textTitleValue: {
      fontSize: 12,
      color: '#000',
      margin: '0px!important',
    },
    img: {
      width: 60,
      height: 60,
      borderRadius: 10,
      marginLeft: 5,
      objectFit: 'contain',
    },
    gridBannerValueDefault: {
      borderRadius: '10px 10px 0 0',
      color: '#000',
      fontSize: 9,
      margin: '0px!important',
    },

    textTagLive: {
      margin: '0px 0 5px 0!important',
      backgroundColor: '#298000',
      borderRadius: 5,
      padding: '0px 10px',
      color: '#fff',
      alignItems: 'center',
      textTransform: 'uppercase',
      fontWeight: 550,
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      fontSize: 12,
    },
    pTypeNotice: {
      marginLeft: '5px',
      padding: '2px 3px',
      borderRadius: '5px',
      background: '#D9E0E9',
      color: '#444',
    },
    gridTypeNotice: {
      flexDirection: 'column',
      display: 'flex',
      alignItems: 'center',
    },

    gridFavorite: {
      width: '100%',
      justifyContent: 'center',
    },
    iconFavorite: {
      width: 20,
      height: 18,
    },
    gridPromotionContent: {
      width: '87%',
      maxWidth: '583px',
      [theme.breakpoints.down('sm')]: {
        width: '86%',
      },
      [theme.breakpoints.down('xs')]: {
        width: '80%',
      },
    },
  }),
);

export default useStyles;
